// Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
// import Header from "./Header";
import Footer from "./Footer";
import Headeralt from "./Headeralt";

const Layout = () => {
    return (
        <div className="layout">
            <Headeralt />
            {/* Page content loads here */}
            <main style={{ minHeight: "85vh" }}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
